module.exports = __webpack_public_path__ + "img/营业执照副本加水印.ea70818e.png";